import { render, staticRenderFns } from "./fee-reduction.vue?vue&type=template&id=1e6d523a&scoped=true"
import script from "./fee-reduction.vue?vue&type=script&lang=js"
export * from "./fee-reduction.vue?vue&type=script&lang=js"
import style0 from "./fee-reduction.vue?vue&type=style&index=0&id=1e6d523a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6d523a",
  null
  
)

export default component.exports